import React from 'react'
import PropTypes from 'prop-types'

import { attributesNames } from '../../../constants'
import { GlobalAttributeTabsDialog } from '../../../containers'
import { Icon, iconNames } from '../../icons'
import { Button } from '../Button'
import './style.scss'

export const ButtonFx = (props) => {
  const { currentProject, currentScenario, openDialog, setOpenDialog, variables, onClick } = props

  const ____importProjectGlobals = () => {}

  return (
    <>
      <Button
        icon={<Icon name={iconNames.FUNCTION} size={18} />}
        className="buttonFunction"
        onClick={onClick}
        {...props}
      />
      {openDialog && (
        <GlobalAttributeTabsDialog
          currentProject={currentProject}
          currentScenario={currentScenario}
          tabValue={0}
          tabIdentifier={[attributesNames.VARIABLES]}
          setTabValue={() => {}}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          actionDispatchImport={____importProjectGlobals}
          // -- MUST be only one visible
          tabVisible={{
            weather_data: false,
            locations: false,
            resources: false,
            products: false,
            variables: true,
            parameters: false
          }}
          selectedAttributes={{ variables }}
          loadData={null}
        />
      )}
    </>
  )
}

ButtonFx.displayName = 'ButtonFx'

ButtonFx.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  variables: PropTypes.arrayOf(PropTypes.object),
  openDialog: PropTypes.bool,
  setOpenDialog: PropTypes.func,
  onClick: PropTypes.func.isRequired
}

ButtonFx.defaultProps = {
  currentProject: null,
  currentScenario: null,
  variables: [],
  openDialog: false,
  setOpenDialog: () => {},
  onClick: () => {}
}
